<button
  *ngIf="showManualButton"
  type="button"
  class="manuale-trigger"
  aria-label="Apri manuale"
  title="Apri manuale"
  (click)="toggleManual()"
>
  <mat-icon>menu_book</mat-icon>
</button>

<aside
  *ngIf="(showManualButton || manualOpen) && manualOpen"
  class="manuale-panel"
  role="dialog"
  aria-modal="true"
  aria-label="Manuale della pagina"
>
  <header class="manuale-panel-header">
    <h2>Manuale</h2>
    <button type="button" mat-icon-button aria-label="Chiudi manuale" (click)="closeManual()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="manuale-panel-content" [ngSwitch]="manualPage">
    <ng-container *ngSwitchCase="'home'">
      <section class="manuale-action">
        <h3>Orientarsi nell’area DLS</h3>
        <p>Usa la pagina iniziale per raggiungere le funzioni disponibili per il tuo profilo.</p>
        <ol>
          <li>Leggi le informazioni mostrate nella pagina.</li>
          <li>Seleziona il pulsante dell’area che vuoi utilizzare.</li>
          <li>Usa il menu principale per passare a un’altra sezione DLS.</li>
        </ol>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'compilazioni'">
      <section class="manuale-action">
        <h3>Cercare una compilazione</h3>
        <p>Trova rapidamente un documento usando il titolo o il filtro dedicato.</p>
        <ol>
          <li>Inserisci una parola nel campo di ricerca.</li>
          <li>
            Seleziona
            <strong>Moduli non ancora compilati</strong>
            per mostrare i documenti ancora da completare.
          </li>
          <li>Cancella la ricerca per tornare all’elenco completo.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Aprire un documento</h3>
        <p>Apri una compilazione per leggerla, stamparla o iniziare il lavoro.</p>
        <ol>
          <li>Individua il documento nell’elenco.</li>
          <li>
            Seleziona
            <strong>Visualizza</strong>
            oppure
            <strong>Compila</strong>
            .
          </li>
          <li>Usa il pulsante indietro per tornare all’elenco.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Stampare o consultare l'archivio</h3>
        <p>Le azioni della riga permettono di stampare il documento o vedere le versioni precedenti.</p>
        <ol>
          <li>Individua il documento interessato.</li>
          <li>
            Seleziona
            <strong>Stampa</strong>
            per produrre una copia.
          </li>
          <li>
            Seleziona
            <strong>Archivio</strong>
            per consultare le compilazioni salvate.
          </li>
        </ol>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'compilazioni-dettaglio'">
      <section class="manuale-action">
        <h3>Compilare un documento</h3>
        <p>Inserisci o aggiorna le informazioni richieste nei campi del documento.</p>
        <ol>
          <li>Compila i campi seguendo l’ordine del documento.</li>
          <li>Controlla i dati prima di salvare.</li>
          <li>
            Seleziona
            <strong>Salva</strong>
            per registrare il lavoro.
          </li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Stampare la compilazione</h3>
        <p>Produci una copia del documento dopo averlo salvato.</p>
        <ol>
          <li>Salva la compilazione.</li>
          <li>
            Seleziona
            <strong>Stampa</strong>
            .
          </li>
          <li>Controlla l’anteprima e completa la stampa.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Creare una nuova compilazione</h3>
        <p>Riutilizza una compilazione precedente come punto di partenza.</p>
        <ol>
          <li>Apri una compilazione già salvata.</li>
          <li>
            Seleziona
            <strong>Crea nuova compilazione partendo da questa</strong>
            .
          </li>
          <li>Aggiorna i dati necessari e salva il nuovo documento.</li>
        </ol>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'abbonamento'">
      <section class="manuale-action">
        <h3>Controllare l’abbonamento</h3>
        <p>Verifica stato, piano, date di validità e quesiti disponibili.</p>
        <ol>
          <li>Leggi il riepilogo dell’abbonamento.</li>
          <li>Controlla la data di scadenza e il numero di quesiti residui.</li>
          <li>Apri la sezione delle fatture per consultare i documenti disponibili.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Gestire il rinnovo</h3>
        <p>Gestisci il rinnovo automatico quando l’opzione è disponibile.</p>
        <ol>
          <li>
            Seleziona
            <strong>Cancella abbonamento</strong>
            per interrompere il rinnovo.
          </li>
          <li>Leggi il messaggio di conferma.</li>
          <li>
            Se cambi idea, seleziona
            <strong>Annulla cancellazione</strong>
            prima della scadenza.
          </li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Acquistare quesiti extra</h3>
        <p>Aggiungi quesiti quando quelli disponibili non sono sufficienti.</p>
        <ol>
          <li>Scegli la quantità di quesiti da acquistare.</li>
          <li>Controlla il riepilogo dell’importo.</li>
          <li>Completa il pagamento seguendo le istruzioni mostrate.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Acquistare ore di consulenza</h3>
        <p>Le ore richieste per una consulenza si acquistano dalla relativa conversazione.</p>
        <ol>
          <li>Apri la conversazione di consulenza.</li>
          <li>
            Seleziona
            <strong>Acquista ore mancanti</strong>
            quando il comando è disponibile.
          </li>
          <li>Completa il pagamento seguendo le istruzioni mostrate.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Aprire le funzioni collegate</h3>
        <p>Raggiungi rapidamente consulenza, corso e fatture dall’abbonamento.</p>
        <ol>
          <li>
            Seleziona
            <strong>Chiedi al consulente</strong>
            per aprire l’area dei quesiti.
          </li>
          <li>
            Seleziona
            <strong>Vai al corso</strong>
            per accedere alla formazione.
          </li>
          <li>Apri una fattura dalla relativa scheda.</li>
        </ol>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'storico-fatture'">
      <section class="manuale-action">
        <h3>Consultare una fattura</h3>
        <p>Usa lo storico per trovare e leggere le fatture dell’abbonamento.</p>
        <ol>
          <li>Scorri l’elenco delle fatture.</li>
          <li>Individua la fattura per data o descrizione.</li>
          <li>Seleziona la fattura per aprirla o scaricarla, quando l’azione è disponibile.</li>
        </ol>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'contatta-consulente'">
      <section class="manuale-action">
        <h3>Consultare un quesito</h3>
        <p>
          I quesiti sono ordinati dal piu recente. I quesiti evidenziati sono quelli per cui l'utente attende una
          risposta
        </p>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'contatta-consulente-dettaglio'">
      <section class="manuale-action">
        <h3>Terminare un quesito</h3>
        <p>Dopo la chiusura non è possibile aggiungere nuovi messaggi.</p>
        <ol>
          <li>
            Seleziona
            <strong>Termina conversazione</strong>
            .
          </li>
          <li>Controlla il testo proposto e completalo se necessario.</li>
          <li>
            Seleziona
            <strong>Invia e chiudi</strong>
            .
          </li>
        </ol>
        <p class="manuale-note">Se l'utente non risponde entro 14 giorni il quesito viene chiuso automaticamente.</p>
      </section>
      <section class="manuale-action">
        <h3>Segnalare un messaggio non pertinente</h3>
        <p>Indica che il contenuto non può essere gestito come richiesta di consulenza.</p>
        <ol>
          <li>
            Seleziona
            <strong>Messaggio non pertinente</strong>
            .
          </li>
          <li>Controlla il testo proposto e completalo se necessario.</li>
          <li>Invia il messaggio e termina la conversazione.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Restituire un quesito</h3>
        <p>
          In ogni momento fino al terminedella conversazione l'operatore puo' restituire il quesito che e' stato scalato
          dal bilancio dell'utente all'apertura della conversazione.
        </p>
      </section>
      <section class="manuale-action">
        <h3>Gestire una consulenza</h3>
        <p>
          In ogni momento l'operatore puo' trasformare un quesito inuna consulenza con il tasto "Trasforma in
          consulenza".
        </p>
        <p>
          Nell'alert successivo si puo' gia' richiedere all'utente di acquistare un dato numero di ore di consulenza, ma
          se ancora non si conosce l'importo di ore necessario si puo' lasciare 0 e richiedere le ore successivamente.
        </p>
        <p>
          Notare che si puo' sempre richiedere l'acquisto di ore aggiuntive ma mai dedurre ore non usate, o spostarlesu
          un altra consulenza.
        </p>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'contenuti'">
      Questa pagina è usata dagli utenti abbonati per visualizzare il contenuto disponibile.
      <br />
      <section class="manuale-action">
        <h3>Cercare un contenuto</h3>
        <p>Trova un contenuto usando il titolo o la categoria.</p>
        <ol>
          <li>Inserisci una parola nel campo di ricerca.</li>
          <li>Seleziona la categoria o il tipo di contenuto desiderato.</li>
          <li>Controlla i risultati mostrati.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Creare altri contenuti</h3>
        <p>
          Per creare o gestire contenuti, vai a
          <a routerLink="/dls/contenuto-privacy">Gestione contenuti</a>
          .
        </p>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'contenuto-dettaglio'">
      <section class="manuale-action">
        <h3>Leggere un articolo</h3>
        <p>Consulta il contenuto completo e i relativi materiali.</p>
        <ol>
          <li>Scorri il testo dell’articolo.</li>
          <li>Apri eventuali collegamenti o materiali inclusi.</li>
          <li>Usa il pulsante indietro per tornare ai contenuti.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Riprodurre un video o un podcast</h3>
        <p>Avvia i contenuti multimediali direttamente dalla pagina.</p>
        <ol>
          <li>
            Seleziona
            <strong>Play</strong>
            nel lettore.
          </li>
          <li>Metti in pausa o riprendi la riproduzione quando necessario.</li>
          <li>Regola il volume dal lettore del dispositivo.</li>
        </ol>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'contenuto-privacy'">
      <section class="manuale-action">
        <h3>Filtrare i contenuti</h3>
        <p>
          Riduci l’elenco usando tipo, autore o visibilità. Le selezioni si sommano: vengono mostrati solo i contenuti
          che rispettano tutte le scelte effettuate.
        </p>
        <p>
          Se compare
          <strong>Nessun contenuto</strong>
          , non ci sono risultati che rispettano tutte le selezioni correnti. Prova a rimuovere uno o più filtri.
        </p>
      </section>
      <section class="manuale-action">
        <h3>Gestire i contenuti in evidenza</h3>
        <p>Scegli fino a 6 contenuti pubblici da mostrare in evidenza sul sito vetrina.</p>
        <ol>
          <li>
            Seleziona la
            <mat-icon class="manuale-step-icon">star</mat-icon>
            <strong>stella</strong>
            nella riga di un contenuto pubblico.
          </li>
          <li>Usa le frecce su e giù per modificarne l’ordine.</li>
          <li>Usa il cestino per rimuovere un contenuto dalla selezione.</li>
          <li>
            Seleziona
            <strong>Aggiorna evidenza</strong>
            per confermare l’elenco e l’ordine.
          </li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Creare un contenuto</h3>
        <p>Aggiungi un nuovo articolo, podcast o video.</p>
        <ol>
          <li>
            Seleziona
            <strong>Nuovo contenuto</strong>
            .
          </li>
          <li>Scegli il tipo di contenuto.</li>
          <li>Compila i dati richiesti e salva.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Modificare o rendere visibile un contenuto</h3>
        <p>Nella colonna Azioni trovi due icone:</p>
        <ol>
          <li>
            <mat-icon class="manuale-step-icon">edit</mat-icon>
            <strong>Matita</strong>
            : apre la pagina di modifica del contenuto.
          </li>
          <li>
            <mat-icon class="manuale-step-icon">remove_red_eye</mat-icon>
            <strong>Occhio</strong>
            : apre le opzioni di visibilità.
            <ul class="manuale-submenu">
              <li>
                <strong>Mostra ovunque</strong>
                : il contenuto è visibile sia agli utenti abbonati sia sul sito vetrina pubblico.
              </li>
              <li>
                <strong>Nascondi solo sito vetrina</strong>
                : il contenuto resta visibile agli utenti abbonati, ma non nel sito vetrina.
              </li>
              <li>
                <strong>Nascondi ovunque</strong>
                : il contenuto non è visibile agli utenti, solo agli operatori.
              </li>
            </ul>
          </li>
        </ol>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'contenuto-privacy-upsert'">
      <section class="manuale-action">
        <h3>Campi comuni</h3>
        <p>Questi campi sono presenti per ogni tipo di contenuto.</p>
        <ul class="manuale-fields-list">
          <li>
            <strong>Titolo: obbligatorio.</strong>
            È il nome con cui il contenuto verrà riconosciuto.
          </li>
          <li>
            <strong>Sottotitolo: facoltativo.</strong>
            Può essere lasciato vuoto.
          </li>
          <li>
            <strong>Copertina: facoltativa.</strong>
            Se utilizzata, deve essere JPG o PNG e non superare 5 MB.
          </li>
        </ul>
      </section>
      <section class="manuale-action">
        <h3>Creare un articolo</h3>
        <p>
          Per un articolo è obbligatorio inserire il testo. L’
          <strong>Abstract</strong>
          è facoltativo e viene usato sul sito vetrina come breve descrizione o anteprima dell’articolo per gli articoli
          con visibilita' per soli abbonati.
        </p>
        <ol>
          <li>
            Scegli
            <strong>Articolo</strong>
            .
          </li>
          <li>
            Compila il
            <strong>Titolo</strong>
            .
          </li>
          <li>
            Inserisci
            <strong>Testo dell’articolo</strong>
            : è obbligatorio.
          </li>
          <li>Aggiungi, se vuoi, sottotitolo e copertina.</li>
          <li>
            Seleziona
            <strong>Crea contenuto</strong>
            .
          </li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Creare un podcast</h3>
        <p>Per un podcast è obbligatorio selezionare un file audio.</p>
        <ol>
          <li>
            Scegli
            <strong>Podcast</strong>
            .
          </li>
          <li>
            Compila il
            <strong>Titolo</strong>
            .
          </li>
          <li>
            Seleziona l’
            <strong>Audio</strong>
            : è obbligatorio e deve essere MP3, WAV o OGG.
          </li>
          <li>Aggiungi, se vuoi, sottotitolo e copertina.</li>
          <li>
            Seleziona
            <strong>Crea contenuto</strong>
            .
          </li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Creare un video</h3>
        <p>Per un video è obbligatorio inserire il collegamento YouTube.</p>
        <ol>
          <li>
            Scegli
            <strong>Video</strong>
            .
          </li>
          <li>
            Compila il
            <strong>Titolo</strong>
            .
          </li>
          <li>
            Inserisci il
            <strong>Link YouTube</strong>
            : è obbligatorio.
          </li>
          <li>Aggiungi, se vuoi, sottotitolo e copertina.</li>
          <li>
            Seleziona
            <strong>Crea contenuto</strong>
            .
          </li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Annullare la creazione</h3>
        <p>Torna all’elenco senza salvare il contenuto.</p>
        <ol>
          <li>
            Seleziona
            <strong>Annulla</strong>
            .
          </li>
          <li>Conferma l’uscita se viene mostrato un avviso per modifiche non salvate.</li>
        </ol>
      </section>
    </ng-container>
    <ng-container *ngSwitchCase="'contenuto-privacy-upsert-modifica'">
      <section class="manuale-action">
        <h3>Campi obbligatori e facoltativi</h3>
        <p>Le regole dipendono dal tipo di contenuto e restano valide anche durante la modifica.</p>
        <ul class="manuale-fields-list">
          <li><strong>Titolo: obbligatorio.</strong></li>
          <li><strong>Sottotitolo: facoltativo.</strong></li>
          <li>
            <strong>Abstract: facoltativo</strong>
            per gli articoli. Viene usato sul sito vetrina come breve descrizione o anteprima, distinta dal testo
            completo.
          </li>
          <li>
            <strong>Copertina: facoltativa.</strong>
            Deve essere JPG o PNG e non superare 5 MB.
          </li>
          <li>
            <strong>Testo articolo: obbligatorio</strong>
            per gli articoli.
          </li>
          <li>
            <strong>Audio: obbligatorio</strong>
            per i podcast.
          </li>
          <li>
            <strong>Link YouTube: obbligatorio</strong>
            per i video.
          </li>
        </ul>
      </section>
      <section class="manuale-action">
        <h3>Bottoni modifica articolo</h3>
        <p>Formattazione testo.</p>
        <ul class="manuale-fields-list">
          <li>
            <strong>B</strong>
            : Grassetto
          </li>
          <li>
            <strong>I</strong>
            : Corsivo
          </li>
          <li>
            <strong>U</strong>
            : Sottolineato
          </li>
          <li>
            <strong>H1</strong>
            : Testo grande 1
          </li>
          <li>
            <strong>H2</strong>
            : Testo grande 2
          </li>
          <li><strong>Elenco numerato</strong></li>
          <li><strong>Elenco puntato</strong></li>
          <li>
            <strong>Link</strong>
            : Aggiungi link
          </li>
          <li>
            <strong>Reset</strong>
            : Rimuovi formattazione
          </li>
        </ul>
      </section>
      <section class="manuale-action">
        <h3>Salvare una modifica</h3>
        <p>Aggiorna solo i dati necessari e conserva il contenuto modificato.</p>
        <ol>
          <li>Modifica i campi desiderati.</li>
          <li>Controlla che tutti i campi obbligatori siano compilati.</li>
          <li>
            Seleziona
            <strong>Aggiorna contenuto</strong>
            .
          </li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Annullare le modifiche</h3>
        <p>Torna all’elenco senza salvare il lavoro corrente.</p>
        <ol>
          <li>
            Seleziona
            <strong>Annulla</strong>
            .
          </li>
          <li>Conferma l’uscita se viene mostrato un avviso.</li>
        </ol>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'webinar'">
      <p>Questa pagina è utilizzata dagli utenti abbonati per vedere i webinar live e quelli conclusi.</p>
      <section class="manuale-action">
        <h3>Gestione webinar</h3>
        <p>
          I webinar vengono gestiti dal canale YouTube
          <a href="https://www.youtube.com/@slcdpo" target="_blank" rel="noopener noreferrer">
            https://www.youtube.com/@slcdpo
          </a>
          .
        </p>
        <p>
          Per avviare un webinar, bisogna prima avviare una live dal canale, quindi cliccare il tasto 'Sincronizza
          webinar' presente su questa pagina. Il webinar diventerà automaticamente visibile a tutti gli abbonati.
        </p>
        <p>
          Il badge
          <span class="manuale-live-badge">
            <span class="manuale-live-dot"></span>
            In diretta
          </span>
          sarà visibile in cima alla pagina e nel menu di sinistra, alla voce
          <strong>Webinar</strong>
          .
        </p>
        <p>
          Una volta che il webinar è terminato su youtube, passerà nella sezione storico automaticamente con un delay di
          alcuni minuti.
        </p>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="'community'">
      <section class="manuale-action">
        <h3>Cercare nella Community</h3>
        <p>Trova discussioni e messaggi usando il testo o un hashtag.</p>
        <ol>
          <li>Inserisci il testo nella ricerca.</li>
          <li>Seleziona l’azione di ricerca.</li>
          <li>Apri un risultato per leggere la discussione.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Cercare un hashtag</h3>
        <p>Usa gli hashtag popolari per trovare discussioni collegate.</p>
        <ol>
          <li>Seleziona un hashtag visualizzato nella pagina.</li>
          <li>Controlla l’elenco delle discussioni collegate.</li>
          <li>Apri il risultato desiderato.</li>
        </ol>
      </section>
    </ng-container>
    <ng-container *ngSwitchCase="'community-ricerca'">
      <section class="manuale-action">
        <h3>Leggere i risultati della ricerca</h3>
        <p>Consulta le discussioni trovate dalla ricerca testuale o per hashtag.</p>
        <ol>
          <li>Controlla il numero e il tipo dei risultati.</li>
          <li>Seleziona una discussione per aprirla.</li>
          <li>Usa il paginatore per vedere altri risultati.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Aggiornare la ricerca</h3>
        <p>Ripeti la ricerca quando vuoi verificare nuovi risultati.</p>
        <ol>
          <li>Modifica il testo o l’hashtag cercato.</li>
          <li>
            Seleziona
            <strong>Cerca</strong>
            .
          </li>
          <li>Apri il risultato aggiornato.</li>
        </ol>
      </section>
    </ng-container>
    <ng-container *ngSwitchCase="'community-categoria'">
      <section class="manuale-action">
        <h3>Consultare le discussioni</h3>
        <p>Leggi le discussioni della categoria e apri quella che ti interessa.</p>
        <ol>
          <li>Scorri l’elenco.</li>
          <li>Usa il paginatore per vedere altre discussioni.</li>
          <li>Seleziona il titolo della discussione.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Creare una discussione</h3>
        <p>Avvia una nuova discussione quando l’azione è disponibile.</p>
        <ol>
          <li>
            Seleziona
            <strong>Nuova discussione</strong>
            .
          </li>
          <li>Inserisci titolo, testo e hashtag, se necessari.</li>
          <li>Aggiungi eventuali allegati.</li>
          <li>Seleziona il comando di pubblicazione.</li>
        </ol>
      </section>
    </ng-container>
    <ng-container *ngSwitchCase="'community-discussione'">
      <section class="manuale-action">
        <h3>Rispondere a una discussione</h3>
        <p>Aggiungi una risposta alla discussione corrente.</p>
        <ol>
          <li>Scorri fino all’area di risposta.</li>
          <li>Scrivi il messaggio.</li>
          <li>Aggiungi un allegato se necessario.</li>
          <li>
            Seleziona
            <strong>Rispondi</strong>
            o il comando di invio.
          </li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Citare o modificare un messaggio</h3>
        <p>Richiama un messaggio nella risposta o correggi un tuo messaggio.</p>
        <ol>
          <li>Apri il menu del messaggio.</li>
          <li>
            Seleziona
            <strong>Cita</strong>
            oppure
            <strong>Modifica</strong>
            .
          </li>
          <li>Completa la risposta o la modifica.</li>
          <li>Salva o invia.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Gestire la discussione</h3>
        <p>Aggiorna titolo, hashtag, stato o importanza quando le relative azioni sono disponibili.</p>
        <ol>
          <li>Apri il menu della discussione.</li>
          <li>Seleziona l’azione da eseguire.</li>
          <li>Conferma la modifica e controlla il risultato.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Moderare un messaggio</h3>
        <p>Nascondi un messaggio non conforme alle regole della Community.</p>
        <ol>
          <li>Apri il menu del messaggio.</li>
          <li>
            Seleziona
            <strong>Nascondi messaggio</strong>
            .
          </li>
          <li>Controlla il messaggio di conferma.</li>
          <li>Conferma solo dopo aver verificato che l’azione sia necessaria.</li>
        </ol>
      </section>
      <section class="manuale-action">
        <h3>Seguire una discussione</h3>
        <p>Ricevi gli aggiornamenti di una discussione quando l’opzione è disponibile.</p>
        <ol>
          <li>Apri le azioni della discussione.</li>
          <li>
            Seleziona
            <strong>Iscriviti</strong>
            oppure
            <strong>Disiscriviti</strong>
            .
          </li>
          <li>Controlla lo stato aggiornato del comando.</li>
        </ol>
      </section>
    </ng-container>
  </div>
</aside>
